import React, { useEffect } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';
import { useAuth } from '~/hooks';
import { ROUTER_PATHS } from '~/constants';

interface LoginGuardProps {
  component: JSX.Element;
}

const LoginGuard: React.FC<LoginGuardProps> = ({ component }) => {
  const { isAuthenticated, isCode2FAPending } = useAuth();

  return isAuthenticated() && !isCode2FAPending() ? (
    <Redirect to={ROUTER_PATHS.PORTAL.HOME} />
  ) : !isAuthenticated() && isCode2FAPending() ? (
    <Redirect to={ROUTER_PATHS.VERIFY_CODE} />
  ) : (
    <>{component}</>
  );
};

export default LoginGuard;
